import BaseService from "./BaseService";
import { IInstallationLevel } from "../core/contracts/IInstallationLevel";
// import { mockRequest, makeLevelReading } from "./MockService";
import addTime, { isDateValid } from "../helpers/datetime";
import { format, isAfter } from "date-fns";

export type InstallationLevelServiceFetchParams = {
  installation_id: string;
  startDate?: Date;
  endDate?: Date;
  pageSize?: number;
  page?: number;
};

export type InstallationLevelServicePutParams = {
  installationId: string;
  date: Date;
  delivery: boolean;
  readings: putTankReading[];
};

export type putTankReading = {
  tankId: string;
  value: number;
  capacity: number | undefined;
};

export default class InstallationLevelService extends BaseService {
  async fetch(params: InstallationLevelServiceFetchParams): Promise<IInstallationLevel> {
    const { installation_id, startDate, endDate } = params;

    const minDate = addTime(new Date(), -6, "mo");

    const startDateFilter = isDateValid(startDate)
      ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isAfter(minDate, startDate!)
        ? `&start_date=${minDate.toISOString()}`
        : `&start_date=${startDate?.toISOString()}`
      : `&start_date=${addTime(new Date(), -1, "week").toISOString()}`;
    const endDateFilter = isDateValid(endDate)
      ? `&end_date=${endDate?.toISOString()}`
      : `&end_date=${new Date().toISOString()}`;

    try {
      if (!installation_id) {
        return new Promise((_, rej) => rej("invalid installation id!"));
      }

      return await new BaseService().get<IInstallationLevel>(
        `/level?installation_id=${installation_id}${startDateFilter}${endDateFilter}`
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationLevelService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchTrips(params: InstallationLevelServiceFetchParams): Promise<IInstallationLevel> {
    const { installation_id, startDate, endDate } = params;

    const minDate = addTime(new Date(), -6, "mo");

    const startDateFilter = isDateValid(startDate)
      ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isAfter(minDate, startDate!)
        ? `&start_date=${minDate.toISOString()}`
        : `&start_date=${startDate?.toISOString()}`
      : `&start_date=${addTime(new Date(), -1, "week").toISOString()}`;
    const endDateFilter = isDateValid(endDate)
      ? `&end_date=${endDate?.toISOString()}`
      : `&end_date=${new Date().toISOString()}`;

    try {
      if (!installation_id) {
        return new Promise((_, rej) => rej("invalid installation id!"));
      }

      return await new BaseService().get<IInstallationLevel>(
        `/trips?installation_id=${installation_id}${startDateFilter}${endDateFilter}`
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationLevelService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async update(params: InstallationLevelServicePutParams): Promise<boolean> {
    try {
      const { installationId, date, delivery, readings } = params;

      const requestObj = {
        installation_id: installationId,
        last_reading_date: `${format(new Date(date), "yyyy-MM-dd")}T${format(
          new Date(date),
          "HH:mm:ss"
        )}`,
        load_since_last_reading: delivery ? 1 : 0,
        tanks: readings.map((x) => {
          return {
            tank_id: x.tankId,
            level: x.value,
            tank_capacity_in: x.capacity,
          };
        }),
      };

      return new BaseService().post("/send_level/", requestObj);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationLevelService -> put -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
